
import { Routes, Route, Navigate } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { PublicRoute } from "@/components/auth/PublicRoute";
import { PremiumRoute } from "@/components/auth/PremiumRoute";
import Index from "@/pages/Index";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Profile from "@/pages/Profile";
import Dashboard from "@/pages/Dashboard";
import TenderAgent from "@/pages/TenderAgent";
import TenderManagement from "@/pages/TenderManagement";
import OfferManagement from "@/pages/OfferManagement";
import Pricing from "@/pages/Pricing";
import RequestDemo from "@/pages/RequestDemo";
import AboutUs from "@/pages/AboutUs";
import FAQ from "@/pages/FAQ";
import NotificationSettings from "@/pages/NotificationSettings";
import TenderView from "@/pages/TenderView";
import DataIntegration from "@/pages/platform/DataIntegration";
import DocumentManagement from "@/pages/platform/DocumentManagement";
import Agent from "@/pages/platform/Agent";
import TechnicalSupport from "@/pages/support/TechnicalSupport";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import DanishTermsOfService from "@/pages/legal/DanishTermsOfService";
import CompetitorAnalysisPage from "@/pages/CompetitorAnalysis";
import GeminiPlayground from "@/pages/GeminiPlayground";
import LegalAssistance from "@/pages/platform/LegalAssistance";
import CompanyInformation from "@/pages/CompanyInformation";
import OpportunityFinder from "@/pages/OpportunityFinder";
import TranslationsAnalysis from "@/pages/platform/TranslationsAnalysis";
import MarketAnalysisOpportunities from "@/pages/platform/MarketAnalysisOpportunities";
import ReferatTest from "@/pages/ReferatTest";

export function AppRoutes() {
  return (
    <Routes>
      {/* Landing page with redirection for logged-in users */}
      <Route
        path="/"
        element={
          <PublicRoute isLandingPage={true}>
            <Index />
          </PublicRoute>
        }
      />

      {/* Public routes (still accessible when not logged in) */}
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/request-demo" element={<RequestDemo />} />
      {/* About page is still available via direct URL but not linked in navigation */}
      <Route path="/about" element={<AboutUs />} />
      <Route path="/faq" element={<FAQ />} />
      
      {/* Platform pages */}
      <Route path="/platform/data-integration" element={<DataIntegration />} />
      <Route path="/platform/document-management" element={<DocumentManagement />} />
      <Route path="/platform/translations-analysis" element={<TranslationsAnalysis />} />
      <Route path="/platform/agent" element={<Agent />} />
      <Route path="/platform/legal-assistance" element={<LegalAssistance />} />
      <Route path="/platform/market-analysis-opportunities" element={<MarketAnalysisOpportunities />} />
      
      {/* Support and legal pages */}
      <Route path="/support/technical" element={<TechnicalSupport />} />
      <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/legal/terms-of-service" element={<DanishTermsOfService />} />
      <Route path="/legal/terms-of-service-danish" element={<DanishTermsOfService />} />
      
      {/* Authentication routes */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/signup"
        element={
          <PublicRoute>
            <Signup />
          </PublicRoute>
        }
      />

      {/* Protected routes */}
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/company-information"
        element={
          <ProtectedRoute>
            <CompanyInformation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/competitor-analysis"
        element={
          <PremiumRoute>
            <CompetitorAnalysisPage />
          </PremiumRoute>
        }
      />
      <Route
        path="/opportunity-finder"
        element={
          <PremiumRoute>
            <OpportunityFinder />
          </PremiumRoute>
        }
      />
      <Route
        path="/tender-agent"
        element={
          <ProtectedRoute>
            <TenderAgent />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tender-management"
        element={
          <ProtectedRoute>
            <TenderManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tender-view/:tenderId"
        element={
          <ProtectedRoute>
            <TenderView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tender/:tenderId"
        element={
          <ProtectedRoute>
            <TenderView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/offer-management/:tenderId"
        element={
          <ProtectedRoute>
            <OfferManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/notifications"
        element={
          <ProtectedRoute>
            <NotificationSettings />
          </ProtectedRoute>
        }
      />

      {/* Add the Gemini playground route */}
      <Route 
        path="/gemini-playground" 
        element={
          <ProtectedRoute>
            <GeminiPlayground />
          </ProtectedRoute>
        } 
      />

      {/* Add Referat test page */}
      <Route 
        path="/referat-test" 
        element={<ReferatTest />} 
      />

      {/* Catch all route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
